





































































































































































































































import { Component, Ref, Vue } from 'vue-property-decorator'

@Component
export default class FooterSailCroatia extends Vue {
  @Ref() readonly categories!: HTMLElement

  mounted() {
    const categories: HTMLCollection = this.categories.children

    for (const category of Array.from(categories)) {
      category.classList.add('folded')

      category.addEventListener('click', (ev) => {
        const categoryElement = ev.currentTarget as HTMLElement
        categoryElement.classList.toggle('folded')
      })
    }
  }
}
